var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 100,
    viewBox: "0 0 1302 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_379)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_135_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C271.25 70 542.5 -10 813.75 35C994.583 62 1157.33 0 1302 22V80H0V10Z",
    fill: "#FAF6EF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 54.9999C217 21.9999 470.167 84.9999 705.25 51.9999C940.333 19.9999 1121.17 71.9999 1302 57.9999V99.9999H0V54.9999Z",
    fill: "url(#paint0_linear_135_379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72.0001C180.833 50.0001 415.917 90.0001 651 68.0001C886.083 46.0001 1103.08 84.0001 1302 72.0001V100H0V72.0001Z",
    fill: "#FAF6EF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_379",
    x1: 0,
    y1: 41.3999,
    x2: 0,
    y2: 99.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF6EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_135_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/Shape 2.d025d21d14cf5fc6cf66bd433ead8db5.svg";
export { ForwardRef as ReactComponent };